import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../App";

const DEFAULT_CONTACT = {
  email: "hello@rivorajewels.com",
  phone: "+91 99999 99999",
  whatsapp: "919999999999",
  address: "Johri Bazaar, Jaipur\nRajasthan – 302003, India"
};

const DEFAULT_SOCIAL = {
  instagram: "https://instagram.com/rivorajewels",
  facebook: "https://facebook.com",
  gmail: "hello@rivorajewels.com"
};

export default function Footer() {
  const [contactInfo, setContactInfo] = useState(DEFAULT_CONTACT);
  const [socialInfo, setSocialInfo] = useState(DEFAULT_SOCIAL);

  useEffect(() => {
    axios.get(`${API}/admin/content/contact`)
      .then(({ data }) => {
        if (data.content && Object.keys(data.content).length > 0) {
          setContactInfo({ ...DEFAULT_CONTACT, ...data.content });
        }
      })
      .catch(() => {});

    axios.get(`${API}/admin/content/social`)
      .then(({ data }) => {
        if (data.content && Object.keys(data.content).length > 0) {
          setSocialInfo({ ...DEFAULT_SOCIAL, ...data.content });
        }
      })
      .catch(() => {});
  }, []);

  return (
    <footer className="bg-white border-t border-zinc-200 py-24" data-testid="main-footer">
      <div className="px-6 md:px-12 max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-10 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <h3 className="cormorant text-2xl font-light mb-4">RIVORA JEWELS</h3>
            <p className="text-sm text-zinc-600 font-light tracking-wide mb-5">
              Minimal sterling silver jewellery crafted to elevate everyday style.
            </p>
            {/* Social icons — Instagram, Facebook, WhatsApp */}
            <div className="flex gap-3">
              {/* Instagram */}
              <a href={socialInfo.instagram} target="_blank" rel="noopener noreferrer"
                className="h-9 w-9 border border-zinc-200 hover:border-zinc-900 flex items-center justify-center transition-colors group"
                aria-label="Instagram">
                <svg viewBox="0 0 24 24" className="h-4 w-4 text-zinc-500 group-hover:text-zinc-900 transition-colors" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <rect x="2" y="2" width="20" height="20" rx="5" />
                  <circle cx="12" cy="12" r="4.5" />
                  <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
                </svg>
              </a>
              {/* Facebook */}
              <a href={socialInfo.facebook} target="_blank" rel="noopener noreferrer"
                className="h-9 w-9 border border-zinc-200 hover:border-zinc-900 flex items-center justify-center transition-colors group"
                aria-label="Facebook">
                <svg viewBox="0 0 24 24" className="h-4 w-4 text-zinc-500 group-hover:text-zinc-900 transition-colors" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                </svg>
              </a>
              {/* WhatsApp */}
              <a href={`https://wa.me/${contactInfo.whatsapp}`} target="_blank" rel="noopener noreferrer"
                className="h-9 w-9 border border-zinc-200 hover:border-[#25D366] flex items-center justify-center transition-colors group"
                aria-label="WhatsApp">
                <svg viewBox="0 0 24 24" className="h-4 w-4 text-zinc-500 group-hover:text-[#25D366] transition-colors" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">Shop</h4>
            <div className="space-y-2.5">
              <Link to="/shop?best_seller=true" className="block text-sm text-zinc-600 hover:text-zinc-900 transition-colors">Best Sellers</Link>
              <Link to="/shop?category=Rings" className="block text-sm text-zinc-600 hover:text-zinc-900 transition-colors">Rings</Link>
              <Link to="/shop?category=Bracelets" className="block text-sm text-zinc-600 hover:text-zinc-900 transition-colors">Bracelets</Link>
              <Link to="/shop?category=Pendant Chains" className="block text-sm text-zinc-600 hover:text-zinc-900 transition-colors">Pendant Chains</Link>
              <Link to="/shop?category=Earrings" className="block text-sm text-zinc-600 hover:text-zinc-900 transition-colors">Earrings</Link>
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">Company</h4>
            <div className="space-y-2.5">
              <Link to="/story" className="block text-sm text-zinc-600 hover:text-zinc-900 transition-colors">About Us</Link>
              <Link to="/contact" className="block text-sm text-zinc-600 hover:text-zinc-900 transition-colors">Contact</Link>
              <Link to="/contact#faq" className="block text-sm text-zinc-600 hover:text-zinc-900 transition-colors">FAQ</Link>
            </div>
          </div>

          {/* Policies */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">Policies</h4>
            <div className="space-y-2.5">
              <Link to="/policies?tab=shipping" className="block text-sm text-zinc-600 hover:text-zinc-900 transition-colors">Shipping Policy</Link>
              <Link to="/policies?tab=returns" className="block text-sm text-zinc-600 hover:text-zinc-900 transition-colors">Return & Refund</Link>
              <Link to="/policies?tab=privacy" className="block text-sm text-zinc-600 hover:text-zinc-900 transition-colors">Privacy Policy</Link>
              <Link to="/policies?tab=terms" className="block text-sm text-zinc-600 hover:text-zinc-900 transition-colors">Terms & Conditions</Link>
            </div>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">Connect</h4>
            <div className="space-y-2.5">
              <p className="text-sm text-zinc-600">{contactInfo.email}</p>
              {/* Phone as WhatsApp link */}
              <a
                href={`https://wa.me/${contactInfo.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1.5 text-sm text-zinc-600 hover:text-[#25D366] transition-colors"
              >
                <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 flex-shrink-0" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
                </svg>
                {contactInfo.phone}
              </a>
              <p className="text-sm text-zinc-600 whitespace-pre-line">{contactInfo.address}</p>
            </div>
          </div>
        </div>

        {/* Hallmark badges */}
        <div className="border-t border-zinc-100 pt-8 mb-6">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
            {["✓ 925 Silver", "✓ Hallmarked", "✓ Secure Payments", "✓ Made in Jaipur"].map((badge) => (
              <span key={badge} className="flex items-center gap-1.5 text-[11px] uppercase tracking-widest text-zinc-500">
                <span className="text-[#C9A96E]">{badge.split(" ")[0]}</span>
                <span>{badge.slice(2)}</span>
              </span>
            ))}
          </div>
        </div>

        {/* Payment icons + copyright — same baseline */}
        <div className="border-t border-zinc-100 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-zinc-400 leading-none">
            &copy; 2026 Rivora Jewels. All Rights Reserved.
          </p>
          {/* Payment icons — same height, vertically centred */}
          <div className="flex items-center gap-2">
            <div className="h-6 px-2 border border-zinc-200 rounded flex items-center justify-center bg-white">
              <svg viewBox="0 0 48 16" className="h-3 w-auto" aria-label="Visa">
                <text x="0" y="13" fontFamily="Arial" fontWeight="bold" fontSize="14" fill="#1A1F71">VISA</text>
              </svg>
            </div>
            <div className="h-6 px-2 border border-zinc-200 rounded flex items-center justify-center bg-white gap-0.5">
              <div className="w-3.5 h-3.5 rounded-full bg-[#EB001B]" />
              <div className="w-3.5 h-3.5 rounded-full bg-[#F79E1B] -ml-1.5" />
            </div>
            <div className="h-6 px-2 border border-zinc-200 rounded flex items-center justify-center bg-white">
              <span className="text-[10px] font-bold leading-none" style={{ color: "#097939" }}>UPI</span>
            </div>
            <div className="h-6 px-2 border border-zinc-200 rounded flex items-center justify-center bg-white">
              <span className="text-[10px] font-semibold leading-none text-[#2D81F7]">Razorpay</span>
            </div>
            <div className="h-6 px-2 border border-zinc-200 rounded flex items-center justify-center bg-white">
              <span className="text-[10px] font-semibold leading-none text-zinc-700">G</span><span className="text-[10px] font-semibold leading-none text-[#4285F4]">P</span><span className="text-[10px] font-semibold leading-none text-[#34A853]">a</span><span className="text-[10px] font-semibold leading-none text-[#FBBC05]">y</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
